import { WATCHLIST_WEBSOCKET } from '../utils/constants'
import { getTabId } from '../utils/tabId';

export const getPricingData = (threadUuid, dataGroup=WATCHLIST_WEBSOCKET, ticker_id=null, idx=null, scale=null) => {
  const requestOptions = {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      "X-Tab-Id": getTabId(), 
    },
    body: JSON.stringify({query:
      `{
        watchlistPricingData(dataGroup: "${dataGroup}", tickerId: "${ticker_id}", threadUuid: "${threadUuid}", idx: "${idx}", scale: "${scale}") {
          id
          assetType
          name
          ticker
          exchangeCountry
          action
          change
          updatedAt
          currentPrice
          pricePctChange1d
          pricePctChange24hr
        }
      }`
    })
  };
  fetch('/graphql', requestOptions)
  .then(response => {
    return response.json()
  })
  .then(data => {
  //  console.log("Made Requestion to initiate connection.")
  })
  .catch(error => console.error('Error fetching data:', error));
};
